import backgroundImage from '../../../assets/images/background1.png';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
  id="hero"
  className="relative flex items-center overflow-hidden"
  style={{
  // 背景图核心适配：完整显示+比例锁定
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: 'contain', // 保持图片原始比例，完整显示不裁剪
  backgroundPosition: 'center', // 图片在容器内居中（可根据图片主体调整，如center right）
  backgroundRepeat: 'no-repeat',
  backgroundColor: '#f0f0f0', // 填充色与图片风格协调（建议根据图片主色调微调）

  // 容器高度：按图片实际宽高比动态计算（关键优化）
  minHeight: 'auto', // 取消固定最小高度，完全按比例自适应
  paddingTop: 'clamp(40%, 61.25vw, 61.25%)', // 用clamp限制极端尺寸，核心值61.25%对应图片宽高比（高度/宽度）

  // 顶部间距：随页面缩放动态调整（替代固定57px）
  marginTop: 'clamp(3.5rem, 6.8vw, 3.9rem)', // 小屏约56px，大屏约64px，与header高度比例协调

  position: 'relative',
  overflow: 'hidden' // 防止极端尺寸下内容溢出
}}
>
  {/* 内容容器：绝对定位，覆盖在背景图上方 */}
  <div className="absolute inset-0 flex items-center">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="w-full max-w-4xl lg:max-w-3xl space-y-[clamp(1.5rem,3vw,2.5rem)]">
        {/* 标题：全尺寸动态缩放 */}
        <h1 className="font-bold leading-tight">
          <span className="block text-[clamp(0.5rem,4vw,3rem)] text-white font-mono">
            专业的环境问题解决方案提供商
          </span>
          <span className="block mt-[clamp(0rem,2vw,1.5rem)] text-[clamp(0.3rem,3vw,2.2rem)] text-white font-thin font-mono">
            用科技换新河湖生态，以创新赋能排水系统
          </span>
        </h1>
        {/* 按钮：尺寸随屏幕缩放 */}
        <div className="gap-[clamp(1rem,2vw,1.5rem)]">
          <button
            onClick={() => scrollToSection('contact')}
            className="text-white px-[clamp(1.2rem,2.5vw,2rem)] py-[clamp(0.6rem,1.2vw,0.8rem)] rounded-lg text-[clamp(0.3rem,1.8vw,1.1rem)] font-semibold transition-all whitespace-nowrap cursor-pointer hover:opacity-90 hover:shadow-lg hover:shadow-blue-500/20"
            style={{ backgroundColor: '#4677e0' }}
          >
            咨询解决方案
          </button>
        </div>
      </div>
    </div>
  </div>

  {/* 箭头图标：保持居中与缩放 */}
  <div className="absolute bottom-[clamp(0.1rem,3vw,2rem)] left-0 right-0 w-full flex justify-center px-0 m-0" onClick={() => scrollToSection('about')}>
    <i className="ri-arrow-down-line text-white 
      text-[clamp(0.1rem,3vw,2rem)]  
      bg-black/30 
      p-[clamp(0.1rem,0.8vw,0.6rem)]  
      w-[clamp(0.1rem,6vw,3rem)]  
      h-[clamp(0.1rem,6vw,3rem)]  
      rounded-full 
      flex items-center justify-center 
      box-sizing: border-box 
      animate-bounce"
    ></i>
  </div>
</section>
  );
}
